import { Text, View, StyleSheet } from '@react-pdf/renderer'
import PDFBorderedList2 from '@/components/ReportPDF/PDFBorderedList2'
import PDFCell from '@/components/ReportPDF/PDFCell'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFRow from '@/components/ReportPDF/PDFRow'
import baseStyles from '@/components/ReportPDF/styles'
import PDFDivider from '@/components/ReportPDF/PDFDivider'
import React, { useState, useEffect } from 'react'
import { parseDateToTaiwanDateSlash, calculateDateRangeDays } from '../../TaiwanDateConvert'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'

const styles = StyleSheet.create({ listText: { flex: 1, textAlign: 'center' }, ...baseStyles })

const Chapter3Page = ({ reportData, setPage }) => {
  const { reprotDao, phishType, secondaryCompanyNickname, generateStartDate, generateEndDate } =
    reportData || {}
  const { companyName, campaignStartDate, campaignEndDate, campaignDays } = reprotDao || {}
  const service = phishType
  const [showPrefix, setPrefix] = useState(false)

  useEffect(() => {
    if (service === '郵件') {
      setPrefix(true)
    } else {
      setPrefix(false)
    }
  }, [service])

  return (
    <PDFPage title="第三章 介紹" reportData={reportData}>
      <View
        style={{
          width: '100%',
          height: 5, // 設置分隔線的高度
          backgroundColor: 'black', // 設置顏色為黑色
          marginBottom: 30,
        }}
      >
        <PDFDivider style={{ width: '100%' }} />
      </View>
      <Text
        style={{
          marginTop: 20,
        }}
        render={({ pageNumber }) => {
          setPage({ chap3: pageNumber })
        }}
      />

      <Text style={styles.title}>3.1 專案流程</Text>
      <Text
        render={({ pageNumber }) => {
          setPage({ chap3_1: pageNumber })
        }}
      />

      <View style={styles.section}>
        <PDFParagraph>
          <Text style={{ marginBottom: 20 }}>
            <Text>
              {'    '}
              {secondaryCompanyNickname}
            </Text>
            協助
            <Text>{companyName}</Text>
            檢視現有社交工程安全防護，並找出潛在危機，執行項目時程如下：
          </Text>
        </PDFParagraph>

        <PDFBorderedList2
          name={'processinfo'}
          items={[
            <>
              <Text style={[styles.listText, { fontWeight: 'bold' }]}>工作項目</Text>
              <Text style={[styles.listText, { fontWeight: 'bold' }]}>工期</Text>
              <Text style={[styles.listText, { fontWeight: 'bold' }]}>執行日期</Text>
            </>,
            <>
              <Text style={styles.listText}>
                <Text>{`${showPrefix ? '電子' : ''}${service}`}</Text>
                {'社交工程檢測'}
              </Text>
              <Text style={styles.listText}>
                <Text>{campaignDays}</Text>
                {'日'}
              </Text>
              <Text style={{ flex: 1, textAlign: 'center' }}>
                {parseDateToTaiwanDateSlash(campaignStartDate)}至
                {parseDateToTaiwanDateSlash(campaignEndDate)}
              </Text>
            </>,
            <>
              <Text style={styles.listText}>
                {'\u3000\u3000\u3000\u3000'}製作檢測報告書{'\u3000\u3000\u3000\u3000'}
              </Text>
              <Text style={styles.listText}>
                <Text>{calculateDateRangeDays(generateStartDate, generateEndDate)}</Text>
                {'日'}
              </Text>
              <Text style={{ flex: 1, textAlign: 'center' }}>
                {parseDateToTaiwanDateSlash(generateStartDate)}至
                {parseDateToTaiwanDateSlash(generateEndDate)}
              </Text>
            </>,
          ]}
        />
      </View>

      <Text style={styles.title}>3.2 專案執行項目</Text>

      <Text
        render={({ pageNumber }) => {
          setPage({ chap3_2: pageNumber })
        }}
      />

      <View style={styles.section}>
        <PDFParagraph>
          <Text style={{ marginBottom: 20 }}>
            {'    '}
            社交工程
            <Text>{service}</Text>
            測試服務建議執行之項目如下：
          </Text>
        </PDFParagraph>

        <PDFRow>
          <PDFCell flex={1}>
            <Text>項次</Text>
          </PDFCell>
          <PDFCell flex={3}>
            <Text>項目</Text>
          </PDFCell>
          <PDFCell flex={15}>
            <Text>內容說明</Text>
          </PDFCell>
        </PDFRow>

        <PDFRow height={230}>
          <PDFCell flex={1}>
            <Text>1</Text>
          </PDFCell>
          <PDFCell flex={3}>
            <Text>測試內容</Text>
          </PDFCell>
          <PDFCell flex={15} style={{ alignItems: 'flex-start' }}>
            <Text style={{ marginBottom: 10 }}>
              <Text>• </Text>
              郵件內容設計可涵蓋不同類型，供受測機關隨機挑選進行測試。
            </Text>
            <Text style={{ marginBottom: 10 }}>
              <Text>• </Text>
              測試系統將即時記錄受測信箱之
              <Text>「瀏覽郵件」、「點閱連結」、「開</Text>
            </Text>
            <Text style={{ marginBottom: 10, paddingLeft: 30 }}>
              <Text>啟附件」及「輸入資料」</Text>
              等行為。
            </Text>
            <Text style={{ marginBottom: 10 }}>
              <Text>• </Text>
              測試系統可自動偽造寄件人信箱寄送測試信，大幅增加測試有效率。
            </Text>
            <Text style={{ marginBottom: 10, paddingLeft: 30 }}>
              例如：系統偽造受測人的同事、主管或大型入口網站、電子商務網站
            </Text>
            <Text style={{ paddingLeft: 30 }}>的信箱地址寄出測試釣魚信件。</Text>
          </PDFCell>
        </PDFRow>

        <PDFRow height={240}>
          <PDFCell flex={1}>
            <Text>2</Text>
          </PDFCell>
          <PDFCell flex={3}>
            <Text>分析報告</Text>
          </PDFCell>
          <PDFCell flex={15} style={{ alignItems: 'flex-start' }}>
            <Text style={{ marginBottom: 10 }}>
              <Text>• </Text>
              整體結果統計圖表。
            </Text>
            <Text style={{ marginBottom: 10 }}>
              <Text>• </Text>
              統計
              <Text>「瀏覽郵件」、「點閱連結」、「開啟附件」及「輸入資料」</Text>等
            </Text>
            <Text style={{ marginBottom: 10, paddingLeft: 30 }}>受測者行為。</Text>
            <Text style={{ marginBottom: 10 }}>
              <Text>• </Text>
              統計
              <Text>「瀏覽郵件率」與「連結點閱率」、「開啟附件率」及</Text>
            </Text>
            <Text style={{ marginBottom: 10, paddingLeft: 30 }}>
              <Text>「輸入資料率」</Text>等結果圖表。
            </Text>
            <Text>
              <Text>• </Text>
              個別受測者瀏覽及點閱等行為細部時間行為列表。
            </Text>
          </PDFCell>
        </PDFRow>

        <PDFRow height={120}>
          <PDFCell flex={1}>
            <Text>3</Text>
          </PDFCell>
          <PDFCell flex={3}>
            <Text>諮詢服務</Text>
          </PDFCell>
          <PDFCell flex={15} style={{ alignItems: 'flex-start' }}>
            <Text style={{ marginBottom: 10 }}>
              • 分析報告提出後提供相關
              <Text style={{ fontWeight: 'bold' }}>諮詢服務</Text>。
            </Text>
            <Text>
              • 資安諮詢服務團隊皆擁有
              <Text style={{ fontWeight: 'bold' }}>CEH </Text>或
              <Text style={{ fontWeight: 'bold' }}> CISSP</Text>等國際資安證照。
            </Text>
          </PDFCell>
        </PDFRow>
      </View>
    </PDFPage>
  )
}

export default Chapter3Page
